<template>
  <div class="tags">
    <div v-if="showLabel" class="flex mb-[10px] mt-[34px] font-600">
      <div>
        {{ t('canvasUI.browserApp.fileSelectionInfo.sections.tags.title') }}
      </div>
    </div>
    <div class="flex flex-wrap center-items gap-1">
      <CTag v-for="(tag, index) in tagsToRender" :key="index" class="truncate" round>
        {{ tag }}
      </CTag>
      <div v-if="(file?.tags?.length ?? 0) > tagsToRender.length" class="ml-2">
        {{
          t(
            'canvasUI.browserApp.fileSelectionInfo.sections.tags.andMoreTags',
            (file?.tags?.length ?? 0) - maxTagsToRender,
          )
        }}
      </div>
      <div v-if="!file?.tags?.length" class="mt-1 tags__no-tags">
        {{ t('canvasUI.browserApp.fileSelectionInfo.sections.tags.noTagsCreated') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, type Ref } from 'vue'
import { useI18n } from 'vue-i18n'

import CTag from '@lib/components/CTag/CTag.vue'
import { moreCountBuffer } from '@lib/constants/more.const'
import useThemeVars from '@lib/composables/useThemeVars'
import type { File } from '@openapi'

interface Props {
  maxTagsToRender?: number
  showLabel?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  maxTagsToRender: 5,
  showLabel: true,
})
const cFilePanelProps = inject<{ file?: Ref<File> }>('CFilePanelProps')
const { t } = useI18n()
const themeVars = useThemeVars()
const file = computed(() => cFilePanelProps?.file?.value || null)
const tagsToRender = computed(() => {
  const tags = file.value?.tags || []
  if (tags.length > props.maxTagsToRender + moreCountBuffer) {
    return tags.slice(0, props.maxTagsToRender)
  }
  return tags
})
</script>

<style lang="scss" scoped>
.tags {
  &__no-tags {
    color: v-bind('themeVars.text3');
  }
}

:deep(.n-tag__content) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
